export default __webpack_public_path__ + "static/media/v2.202728e2.webp";